import { connect } from "react-redux";
import { Typography, Grid, Button } from "../ecosystem/";

const SchedulingNoProviders = (props) => {

    const clickFindADoctor = () => {
        props.history.push('/findcare');
    }

    return (
        <Grid fluid className="body-content scheduling-no-providers-container">
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <div className="row">
                        <div className="col-12 schedule-heading">
                            <Typography
                                type="display-01"
                                tag="h1"
                                color={"$color-primary-a3"}
                            >
                                Schedule an Appointment
                            </Typography>
                        </div>
                        <div className="col-12 schedule-descripion">
                            <Typography
                                type="body-02"
                                tag="div"
                                color={"$color-secondary-a1"}
                            >
                                It looks like you don’t have an established relationship with a doctor yet.
                            </Typography>
                        </div>
                        <div className="col-12 schedule-btn-container">
                            <div className="schedule-btn">
                                <Button
                                    fluid
                                    variant="secondary"
                                    onClick={clickFindADoctor}
                                >
                                    FIND A DOCTOR
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Grid>
    );
};

const mapStateToProps = (state) => {
    return {
        history: state.session.history,
    };
};

export default connect(mapStateToProps, null)(SchedulingNoProviders);
